// 任务列表的全局展示排序 —— web / mobile 共用一份（避免两端手工分叉，见
// .claude/rules/local-first-guardrails.md D 节）。
//
// 口径：**priority 降序优先（3 高 → 0 无，即 UI 的 P1 → P4），同优先级内按 sortKey
// （LexoRank 字典序）**，createdAt + id 打破并列（LexoRank 允许两行 sort_key 相等，
// 见 architecture.md；四元组保证全序稳定）。
//
// DnD 语义：拖拽仍只写 sortKey（moveTaskToBucket / reorderTasks 内部用纯 sortKey 序
// 做坐标系，lexorankBetween 边界始终正序）——同优先级内拖拽照常生效；跨优先级拖拽
// 会归位到目标优先级组内靠近落点的位置（与 Todoist 的 priority 排序语义一致）。

export interface TaskSortFields {
  priority: number;
  sortKey: string;
  createdAt: string;
  id: string;
}

export const compareTasks = (a: TaskSortFields, b: TaskSortFields): number =>
  b.priority - a.priority ||
  a.sortKey.localeCompare(b.sortKey) ||
  a.createdAt.localeCompare(b.createdAt) ||
  a.id.localeCompare(b.id);
